import { createContext } from "react";

/** 初回ロードの状態。以後の silent refetch では `success` を維持する。 */
export type CsChatUnreadStatus = "idle" | "loading" | "success" | "error";

export type CsChatUnreadContextType = {
  /** WS 接続に使う channelId。未取得時は null。 */
  channelId: string | null;
  /** チャット画面の表示状態を導出するための初回ロード状態。 */
  status: CsChatUnreadStatus;
  /** サイドメニューのバッジ表示用の未読数。`/support` 表示中は常に 0。 */
  displayUnreadCount: number;
  /** チャットページが markRead を送信したことを通知する（内部状態を 0 に確定）。 */
  notifyMarkRead: () => void;
  /** 未読数を再取得する。 */
  refetch: () => void;
};

export const CsChatUnreadContext = createContext<
  CsChatUnreadContextType | undefined
>(undefined);
